<template>
	<div class="checkout">
    <v-app id="checkout">
      <v-content>
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1" editable>{{ $t('check_destination') }}<small>{{ $t('check_option') }}</small></v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 2" step="2" editable>{{ $t('check_delivery') }}<small>{{ $t('check_option') }}</small></v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 3" step="3" editable>{{ $t('check_summary') }}</v-stepper-step>
            
            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 4" step="4" editable>{{ $t('check_pay') }}</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <article class="message">
                <div class="message-body">
                  <div class="columns">
                    <div class="column is-three-quarters">
                      <v-card-title>{{ $t('check_destination') }}:</v-card-title>
                      <template>
                        <template>
                          <div class="container is-fluid">
                            <div class="columns is-multiline">
                              <div class="column is-3" v-for="address in addresses" :key="address.id">
                                  <b>Name: </b> {{address.name}}<br>
                                  <b>Address: </b> {{address.address}}<br>
                                  <b>Town Name: </b> {{address.town_code}}<br>
                                  <b>Country: </b> {{address.country_code}}
                              </div>
                            </div>
                          </div>
                        </template>
                        <div class="field is-grouped">
                          <p class="control">
                            <v-dialog v-model="changedialog" max-width="600px">
                              <template v-slot:activator="{ on }">
                                <div class="hidden-sm-and-down">
                                  <v-btn color="black darken-2" small rounded dark class="mb-1" v-on="on"  @click="changeNew">Change Transport Address</v-btn>
                                </div>
                                <div class="hidden-md-and-up">
                                  <v-btn color="black darken-2" small rounded dark class="mb-1" v-on="on"  @click="addNew">Change<b>+</b></v-btn>
                                </div>
                              </template>
                              <v-card>
                                <v-data-table :headers="headers" :items="addresses" :search="search" sort-by="name" class="elevation-1">
                                  <template v-slot:item.name="{ item }">
                                    <b>{{ item.name }}</b>
                                  </template>
                                  <template v-slot:top>
                                    <v-toolbar flat color="white">
                                      <v-spacer></v-spacer>
                                      <v-card-title>{{user.name}}'s Addresses</v-card-title>
                                      <v-spacer></v-spacer>
                                    </v-toolbar>
                                  </template>
                                  <template v-slot:item.action="{ item }">
                                    <v-icon
                                      small
                                      class="mr-2"
                                      @click="editTransportAddress(item)"
                                    >
                                      mdi-pencil
                                    </v-icon>
                                    <v-icon
                                      small
                                      @click="deleteTransportAddress(item)"
                                    >
                                      mdi-delete
                                    </v-icon>
                                </template>
                                <template v-slot:no-data>
                                  <v-list-item-title><b>Please Add A Transport Address</b></v-list-item-title>
                                </template>
                                </v-data-table>
                              </v-card>
                            </v-dialog>
                          </p>
                          <p class="control">
                            <v-dialog v-model="dialog" max-width="600px">
                              <template v-slot:activator="{ on }">
                                <div class="hidden-sm-and-down">
                                  <v-btn color="indigo darken-2" small rounded dark class="mb-1" v-on="on"  @click="addNew">Add An Address</v-btn>
                                </div>
                                <div class="hidden-md-and-up">
                                  <v-btn color="indigo darken-2" small rounded dark class="mb-1" v-on="on"  @click="addNew">Address<b>+</b></v-btn>
                                </div>
                              </template>
                              <v-card>
                                <v-card-title>
                                  <span class="headline">{{ formTitle }}</span>
                                </v-card-title>
                                <v-card-text>
                                  <v-container grid-list-md>
                                    <v-layout wrap>
                                      <v-flex xs12>
                                        <v-text-field v-model="transport_destination.name" label="Address Name" hint="My Office, My Home, My Work Place, My Company, etc"></v-text-field>
                                      </v-flex>
                                      <v-flex xs12>
                                        <v-tooltip bottom>
                                          <template v-slot:activator="{ on }">
                                            <span v-on="on">
                                                <v-btn color="indigo" rounded small dark>
                                                  <v-icon @click="locatorButtonPressed">mdi-map-marker</v-icon>
                                                </v-btn>
                                            </span>
                                          </template>
                                          <span>Get Current Location</span>
                                        </v-tooltip>
                                        <v-text-field v-model="transport_destination.address" label="Destination Address"></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 sm6 md6>
                                        <v-autocomplete v-model="transport_destination.town_code" :items="town_code" dense attach chips filled label="Destination District" item-text="name" item-value="slug" prepend-icon="mdi-map"></v-autocomplete>
                                      </v-flex>
                                      <v-flex xs12 sm6 md6>
                                        <v-autocomplete v-model="transport_destination.country_code" :items="country_code" dense attach chips filled label="Destination Country" item-text="name" item-value="countryCode" prepend-icon="mdi-map"></v-autocomplete>
                                      </v-flex> 
                                    </v-layout>
                                  </v-container>
                                </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                  <v-btn color="indigo darken-1" dark small @click="updateTransportAddress" v-if="modal =='edit'">Update Address</v-btn>
                                  <v-btn color="indigo darken-1" dark small @click="addTransportAddress" v-if="modal =='new'">Save Address</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </p>
                        </div>
                      </template>
                    </div>
                    <div class="column is-quarter">
                      <v-autocomplete v-model="checkout.transport_address" :items="addresses" dense attach chips filled label="address" item-text="name" item-value="countryCode" prepend-icon="mdi-car"></v-autocomplete>
                      <v-btn @click="refresh" color="pink" dark rounded>Reset</v-btn>
                    </div>
                  </div>
                </div>
              </article>
              <v-btn text @click="backtocart" color="info">Back to Cart</v-btn>
              <v-btn color="primary" text dark class="mb-2" small @click="e1 = 2">Continue <v-icon>mdi-arrow-right-bold</v-icon></v-btn>             
            </v-stepper-content>

            <v-stepper-content step="2">
              <div class="section">
                <div class="container is-fluid">
                  <div class="columns">
                    <div class="column is-three-quarters">
                      <article class="message">
                        <div class="message-body">
                          <h1 class="title is-5">
                            {{ $t('check_delivery') }}
                          </h1>
                          <div class="select is-fullwidth">
                            <select>
                              <option>
                                Delivery mode  ( Delivery price )
                              </option>
                            </select>
                          </div>
                        </div>
                      </article>
                    </div>
                  </div>
                </div>
              </div>
              <v-btn text  @click="e1 = 1">Back</v-btn>

              <v-btn color="primary" text dark class="mb-2" small @click="e1 = 3">Continue <v-icon>mdi-arrow-right-bold</v-icon></v-btn>
            </v-stepper-content>

            <v-stepper-content step="3">
              <div class="container">
                <div class="columns">
                  <div class="column">
                    <article class="message">
                      <div class="message-body">
                        <v-toolbar flat color="white">
                          <v-card-title>
                            <h1 class="title is-5">
                              {{ $t('check_summary') }}
                            </h1>
                          </v-card-title>
                          <v-spacer></v-spacer>
                          <v-card-title>
                            <v-btn color="blue darken-2" rounded small dark>{{ $t('check_reserves') }}</v-btn> 
                          </v-card-title>
                        </v-toolbar>
                        <v-data-table :headers="cart_overview" :items="cartitems" sort-by="name" class="elevation-1"><!--  -->
                          <template v-slot:item.name="{ item }">
                            <b>{{ item.product_name }}</b>
                          </template>
                          <template v-slot:item.total="{ item }">
                            <b>{{ item.product_total | currency('K ')}}</b>
                          </template>
                          <template v-slot:item.image="{ item }">
                            <v-img height="70px" width="70px" :src="getImage(item.product_image)"></v-img>
                          </template>
                          <template v-slot:item.action="{ item }">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <span v-on="on">
                                    <v-icon medium small color="purple darken-2">mdi-magnet-on</v-icon>
                  <b>({{ item.product_total*0.1 | currency('K ')}})</b>
                                  </span>
                                </template>
                                <span>
                                Reserve For 5 days before you collect @
                          {{ item.product_total*0.1 | currency('K ')}}.
                                </span>
                              </v-tooltip>
                          </template>
                          <template v-slot:no-data>
                            <v-list-item-title><b>Cart Is Empty</b></v-list-item-title>
                          </template>
                        </v-data-table>
                      </div>
                    </article>
                  </div>
                </div>
              </div>
              <v-btn text @click="e1 = 2"><v-icon>mdi-arrow-left-bold</v-icon>Back</v-btn> 
            </v-stepper-content>

            <v-stepper-content step="4">
              <div class="container is-fluid">
                <div class="columns">
                  <v-btn color="indigo" text dark class="mb-2" small @click="e1 = 3"><v-icon>mdi-arrow-left-bold</v-icon> Back</v-btn>
                  <div class="column is-three-quarters">
                    <article class="message">
                      <div class="message-body">
                        <h1 class="title is-5">{{ $t('check_pay') }}</h1>
                        <template>
                          <div class="field is-grouped">
                            <p class="control">
                              <v-dialog v-model="stripedialog" max-width="600px">
                                <template v-slot:activator="{ on }">
                                  <div class="hidden-sm-and-down">
                                    <a><img src="@/assets/stripe.png" lazy-src="@/assets/stripe.png" alt="Stripe" contain height="20" width="70" v-on="on" @click="addStripe"/></a>
                                  </div>
                                  <div class="hidden-md-and-up">
                                    <a><img src="@/assets/stripe.png" lazy-src="@/assets/stripe.png" alt="Stripe" contain height="20" width="70" v-on="on" @click="addStripe"/></a>
                                  </div>
                                </template>
                                <v-card>
                                  <template>
                                    <v-card>
                                      <v-card-title>
                                        <v-text class="headline">Visa Payment Method</v-text>
                                        <v-spacer></v-spacer>
                                        <v-text class="headline">K300</v-text>
                                      </v-card-title>
                                      <v-card-text>
                                        <v-container grid-list-md>
                                          <v-layout wrap>
                                            <!-- <v-flex xs12>
                                              <label>Card Number</label>
                                              <div id="card-number-element" class="input-value"></div>
                                            </v-flex>
                                            <v-flex xs6>
                                              <label>Expiry Date</label>
                                              <div id="card-expiry-element"></div>
                                            </v-flex>
                                            <v-flex xs6>
                                              <label>CVC</label>
                                              <div id="card-cvc-element"></div>
                                            </v-flex> -->
                                            <v-flex xs12>
                                              <b @click="pay">
                                                <v-btn color="blue" rounded dark @click="e1 = 4">Place Order
                                                </v-btn>
                                              </b>
                                            </v-flex>
                                          </v-layout>
                                        </v-container>
                                      </v-card-text>
                                    </v-card>
                                  </template>
                                </v-card>
                              </v-dialog>
                            </p>
                            <p class="control">
                              <v-dialog v-model="airteldialog" max-width="600px">
                                <template v-slot:activator="{ on }">
                                  <div class="hidden-sm-and-down">
                                    <a><img src="@/assets/airtel.png" lazy-src="@/assets/airtel.png" alt="Airtel" contain height="20" width="70" v-on="on" @click="addAirtel"/></a>
                                  </div>
                                  <div class="hidden-md-and-up">
                                    <a><img src="@/assets/airtel.png" lazy-src="@/assets/airtel.png" alt="Airtel" contain height="20" width="70" v-on="on" @click="addAirtel"/></a>
                                  </div>
                                </template>
                                <v-card>
                                  <template>
                                    <v-card>
                                      <v-card-title>
                                        <v-text class="headline">Airtel Money Payment Method</v-text>
                                        <v-spacer></v-spacer>
                                        <v-text class="headline">Available: K200</v-text>
                                      </v-card-title>
                                      <v-card-text>
                                        <v-container grid-list-md>
                                          <v-layout wrap>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">1</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                Visit ConvergeoZm.com and <b>Sign Up</b> or <b>Log in</b>
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">2</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                 Dial <b>*778#</b>
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">3</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                Select <b>4</b> - Make Payment
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">4</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                Select <b>5</b> - Goods & Services
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">5</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                Select <b>1</b> - Enter Merchant Code
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">6</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                Enter business name: <b>convergeo</b>
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">7</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                Enter amount (NO COMMAS) e.g <b>100</b>
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">8</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                Enter reference/invoice number: <b>vergeo</b>
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">9</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                 Enter PIN
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">10</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                You will receive an <b>SMS</b> confirming the transaction
                                              </label>
                                            </v-flex>
                                          </v-layout>
                                        </v-container>
                                      </v-card-text>
                                    </v-card>
                                  </template>
                                </v-card>
                              </v-dialog>
                            </p>
                            <p class="control">
                              <v-dialog v-model="mtndialog" max-width="600px">
                                <template v-slot:activator="{ on }">
                                  <div class="hidden-sm-and-down">
                                    <a><img src="@/assets/mtn.png" lazy-src="@/assets/mtn.png" alt="MTN" contain height="20" width="70" v-on="on" @click="addMtn"/></a>
                                  </div>
                                  <div class="hidden-md-and-up">
                                    <a><img src="@/assets/mtn.png" lazy-src="@/assets/mtn.png" alt="MTN" contain height="20" width="70" v-on="on" @click="addMtn"/></a>
                                  </div>
                                </template>
                                <v-card>
                                  <template>
                                    <v-card>
                                      <v-card-title>
                                        <v-text class="headline">Mtn Money Payment Method</v-text>
                                        <v-spacer></v-spacer>
                                        <v-text class="headline">Available: K150</v-text>
                                      </v-card-title>
                                      <v-card-text>
                                        <v-container grid-list-md>
                                          <v-layout wrap>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">1</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                Visit ConvergeoZm.com and <b>Sign Up</b> or <b>Log in</b>
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">2</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                 Dial <b>*303#</b>
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">3</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                Select <b>2</b>  - Pay Bill
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">4</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                Select <b>4</b> - Goods & Services
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">5</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                Enter Merchant ID: <b>convergeo</b>
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">6</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                Enter amount (NO COMMAS) e.g <b>100</b>
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">7</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                Enter reference/invoice number: <b>vergeo</b>
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">8</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                Enter PIN
                                              </label>
                                            </v-flex>
                                            <v-flex xs12>
                                              <label>
                                                <v-avatar color="black" size="20"><span class="white--text">9</span></v-avatar>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                You will receive an <b>SMS</b> confirming the transaction
                                              </label>
                                            </v-flex>
                                          </v-layout>
                                        </v-container>
                                      </v-card-text>
                                    </v-card>
                                  </template>
                                </v-card>
                              </v-dialog>
                            </p>
                            <p class="control">
                              <v-dialog v-model="zamteldialog" max-width="600px">
                                <template v-slot:activator="{ on }">
                                  <div class="hidden-sm-and-down">
                                    <a><img src="@/assets/zampay.png" lazy-src="@/assets/zampay.png" alt="ZamPay" contain height="20" width="70" v-on="on" @click="addZamtel"/></a>
                                  </div>
                                  <div class="hidden-md-and-up">
                                    <a><img src="@/assets/zampay.png" lazy-src="@/assets/zampay.png" alt="ZamPay" contain height="20" width="70" v-on="on" @click="addZamtel"/></a>
                                  </div>
                                </template>
                                <v-card>
                                  <template>
                                    <v-card>
                                      <v-card-title>
                                        <v-text class="headline">ZamPay Qrcode</v-text>
                                        <v-spacer></v-spacer>
                                        <v-text class="headline">Balance: K100</v-text>
                                      </v-card-title>
                                      <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit">
                                        <div v-show="cameraForzen" class="validation-layer">
                                          <div class="validation-notice" v-if="validating">
                                            Long validation in progress...
                                          </div>

                                          <div class="validation-result" v-if="!validating">
                                            <div v-if="isValid" class="valid">
                                              Valid client
                                            </div>

                                            <div v-else class="invalid">
                                              Not a valid client
                                            </div>
                                          </div>
                                        </div>
                                      </qrcode-stream>
                                    </v-card>
                                  </template>
                                </v-card>
                              </v-dialog>
                            </p>
                          </div>
                        </template>
                      </div>
                    </article>
                  </div>
                </div>
              </div>
              <v-toolbar>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-2" rounded small dark @click="order">
                  View Orders
                </v-btn>
              </v-toolbar>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-content>
    </v-app>
	</div>
</template>

<script>
  import {fb,db} from '@/firebase'
  import axios from 'axios'
  /* eslint-disable */
  var stripe = Stripe("pk_test_pYVjV9tork7KILO1mQbXq8gL00BAepABoL")
  /* eslint-enable */
  export default {
    data: () => ({
      e1: 0,
      user: null,
      dialog: false,
      sessionId: '',
      changedialog: false,
      stripedialog: false,
      airteldialog: false,
      mtndialog: false,
      zamteldialog: false,
      addresses: [],
      checkout: {
        transport_address:''
      },
      cartitems: [],
      town_code: [],
      country_code: [],
      nav_title: 'Checkout',
      amount:300,
      headers: [
        { text: 'Name', align: 'center', value: 'name' },
        { text: 'Address', align: 'center', value: 'address'},
        { text: 'Town', align: 'center', value: 'town_code'},
        { text: 'Country', align: 'center', value: 'country_code'},
        { text: 'Actions', value: 'action', sortable: false },
      ],
      cart_overview: [
        { text: 'Product Image', align: 'center', value: 'image' },
        { text: 'Product Name', align: 'center', value: 'name'},
        { text: 'Product Client', align: 'center', value: 'client_name'},
        { text: 'Region', align: 'center', value: 'client_town'},
        { text: 'Product Total', align: 'center', value: 'total'},
        { text: 'Actions', value: 'action', sortable: false },
      ],
      transport_destination: {
        name: '',
        address: '',
        town_code: '',
        country_code: '',
        user_id: ''
      },
      editedIndex: -1,
      activeItem: '',
      modal: '',
    }),
    created(){
      axios.post('https://us-central1-vergeo-21ffc.cloudfunctions.net/CheckoutSession')
      .then(response => {
        this.sessionId = response.data
      })
      .catch(error => {
        /* eslint-disable */
        console.log(error)
        /* eslint-enable */
      })
      this.uid =fb.auth().currentUser.uid
      db.collection('addresses').where('user','==',fb.auth().currentUser.uid).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let address = doc.data()
          address.id =  doc.id
          this.addresses.push(address) 
        })
      })
      db.collection('cartitems').where('user','==',fb.auth().currentUser.uid).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let cartitem = doc.data()
          cartitem.id =  doc.id
          this.cartitems.push(cartitem) 
        })
      })
      db.collection('user').where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user =doc.data(),
          this.user.id = doc.id//
        })
      })
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Transport Address' : 'Edit Transport Address'
      }
    },
    firestore: () => ({
      town_code: db.collection('town_code'),
      country_code: db.collection('country_code'),
      addresses: db.collection('addresses')
    }),
    watch: {
      dialog (val) {
        val || this.close()
      },
      changedialog (val) {
        val || this.close()
      },
      stripedialog (val) {
        val || this.close()
      },
      airteldialog (val) {
        val || this.close()
      },
      mtndialog (val) {
        val || this.close()
      },
      zamteldialog (val) {
        val || this.close()
      }
    },
    mounted() {
      /* eslint-disable */
      new google.maps.places.Autocomplete(
        this.$refs["autocomplete"]
      );
      /* eslint-enable */
    },
    methods: {
      pay(){
        stripe.redirectToCheckout({
          sessionId: this.sessionId.id
        }).then(() => {
          //
        })
      },
      getImage(product_image){
        return product_image[0]
      },
      addNew(){
        this.modal = 'new'
        this.reset()
        this.dialog = true
      },
      changeNew(){
        this.modal = 'new'
        this.reset()
        this.changedialog = true
      },
      addProductReserve(){

      },
      addStripe(){
        this.stripedialog = true
      },
      addAirtel(){
        this.airteldialog = true
      },
      addMtn(){
        this.mtndialog = true
      },
      addZamtel(){
        this.zamteldialog = true
      },
      reset(){
        this.transport_destination = {
          name: '',
          address: '',
          town_code: '',
          country_code: '',
          user_id: ''
        }  
      },
      refresh(){
        this.checkout = {
          transport_address:''
        }
      },
      addTransportAddress(){
        db.collection('addresses').add({
            name: this.transport_destination.name,
            address: this.transport_destination.address,
            town_code: this.transport_destination.town_code,
            country_code: this.transport_destination.country_code,
            user_id: this.uid
        }).then(() => {
          /* eslint-disable */
          Toast.fire({
            type: 'success',
            title: 'Transport Address Added'
          })
          /* eslint-enable */
          this.close()
        })
      },
      
      updateTransportAddress(){
        this.$firestore.addresses.doc(this.transport_destination.id).update(this.transport_destination)
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'Transport Address Updated'
        })
        /* eslint-enable */
        this.close()
      },

      editTransportAddress(item) {
        this.editedIndex = this.addresses.indexOf(item)
        this.transport_destination = Object.assign({}, item)
        this.modal = 'edit'
        this.dialog = true
      },

      deleteTransportAddress(item) {
        /* eslint-disable */
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            this.$firestore.addresses.doc(item.id).delete()
            Toast.fire({
              type: 'success',
              title: 'Deleted successfully'
            })
          }
        })
        /* eslint-enable */
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.transport_destination = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      async onDecode (content) {
        this.result = content

        this.stopCamera()

        this.validating = true
        this.isValid = await this.validate(content)
        this.validating = false

        window.setTimeout(() => {
          this.startCamera()
        }, 2000)
      },
      async onInit (promise) {
        this.loading = true

        try {
          await promise
        } catch (error) {
          // eslint-disable-next-line
          console.error(error)
        } finally {
          this.firstLoad = false
          this.loading = false
        }
      },
      backtocart(){
        this.$router.push('/cart')
      },
      locatorButtonPressed() {
        navigator.geolocation.getCurrentPosition(
          /* eslint-disable */
          position => {
            this.getStreetAddressFrom(position.coords.latitude, position.coords.longitude)
          },
          error => {
            console.log(error.message);
          }
          /* eslint-enable */
        )
      },
      async getStreetAddressFrom()// lat, long 
      {
        // try {
        //   var { data } = await axios.get(
        //     "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
        //       lat +
        //       "," +
        //       long +
        //       "&key={AIzaSyDHflp-kA8S_bYDw5okd-Uy7CF1MXJMs5U}"
        //   );
        //   if(data.error_message) {
        //      eslint-disable 
        //     console.log(data.error_message)
        //     /* eslint-enable */
        //   } else {
        //     this.address = data.results[0].formatted_address;
        //   }
        // } catch (error) {
        //   /* eslint-disable */
        //   console.log(error.message);
        //   /* eslint-enable */
        // } 
      },
      saveDataToFireStore(stripeObject) {
        const chargesRef = db.collection("charges")
        const pushId = chargesRef.doc().id
        db.collection("charges").doc(pushId).set(stripeObject)
        chargesRef.doc(pushId).onSnapshot(snapShot => {
          const charge = snapShot.data();
          if (charge.error) {
              alert(charge.error);
              chargesRef
              .doc(pushId)
              .delete();
              return;
          }
          if (charge.status && charge.status == "succeeded") {
              alert(charge.status);
          }
        })
      },
      order(){
        this.$router.push('/orders')
      }
    }
  }
</script>

<style>
.payment-form {
    max-width: 400px;
    margin: 20px auto;
    border: 1px solid #ececec;
}
.payment-form h5 {
    margin: 0;
    padding: 10px;
    font-size: 1.2rem;
}
.card-element {
    margin-top: 5px;
}
#card-number-element,
#card-expiry-element,
#card-cvc-element {
    background: white;
    padding: 5px;
    border: 1px solid #ececec;
    height: 30px;
}
.place-order-button-block {
    margin: 10px 0;
}
</style>